/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 05.11.17.
 */

import React from "react";
import PropTypes from "prop-types";
import CONFIG from "../../config";
import BaseActionWizardStep from "../../containers/BaseActionWizardStep";
import {SessionStore} from "../../services/Session";
import ShowQrCodeForm from "./ShowQrCodeForm";
import {PutRestAction} from "../../services/RestAction";

class StepShowQrCode extends BaseActionWizardStep {
    static propTypes = {
        /**
         * Password change initiated from user:
         *  - session - use failed session data
         *  - forgot - use forgot link
         *  - both - use session data
         *  - authkey - use session data
         */
        type: PropTypes.oneOf(["password", "authkey", "both", "session"]),

        personId: PropTypes.string,
        personEmail: PropTypes.string,
        authToken: PropTypes.string,

        onParamChange: PropTypes.func.isRequired,
        params: PropTypes.shape({
            hideForward: PropTypes.bool,
            hideBack: PropTypes.bool,
            disableForward: PropTypes.bool,
            disableBack: PropTypes.bool
        }).isRequired,
        prevParams: PropTypes.shape({
            hideForward: PropTypes.bool,
            hideBack: PropTypes.bool,
            disableForward: PropTypes.bool,
            disableBack: PropTypes.bool,
            componentProps: PropTypes.object
        })
    };

    static defaultProps = {};

    constructor(props) {
        super(props, {
            session: SessionStore,
            person: "person"
        });
        switch (props.type) {
            case "session":
                this.state.authKey = this.state.session.currentRecord.person.authKey;
                this.state.email = this.state.session.currentRecord.person.email;
                this.state.personId = this.state.session.currentRecord.person.id;
                this.changeParam("authKey", this.state.authKey);
                break;

            case "forgot":
                this.state.email = "";
                this.state.authKey = null;
                break;

            case "both":
            case "authkey":
                this.state.email = props.personEmail;
                this.state.personId = props.personId;
                this.state.authKey = null;
                break;
        }
    }

    componentDidMount() {
        // Ask for code:
        switch (this.props.type) {
            case "authkey":
            case "both":
                this.requestCode();
                break;

            case "forgot":
                this.requestSessionCode();
                break;

            default:
                break;
        }
    }

    render() {
        return (<ShowQrCodeForm owner={CONFIG.owner} email={this.state.email} authKey={this.state.authKey}/>);
    }

    requestCode() {
        this.actions("person").put.defer(this.state.personId, {
            email: this.state.email,
            authKey: "GENERATE"
        });
        this.changeParam("disableForward", true);
    }

    requestSessionCode() {
        let tokenParts = this.props.authToken.split("&");
        this.personActionPut(tokenParts[1], {
            authKey: "GENERATE"
        }, this.props.authToken);
        this.changeParam("disableForward", true);
    }

    loadingFinished(key, newState, oldState) {
        if (key === "person") {
            this.setState({
                authKey: newState.currentRecord.authKey,
                email: newState.currentRecord.email
            });
            this.changeParam("authKey", newState.currentRecord.authKey);
            this.changeParam("disableForward", false);
        }
    }

    personActionPut(personId, request, authToken = null) {
        let action = new PutRestAction(personId, request);
        if (authToken) action.authToken = authToken;
        this.actions("person").actionStart.defer(action);
    }

}

export default StepShowQrCode;
